import { useQuery } from '@apollo/client';
import { LiveTv } from '@mui/icons-material';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import { ListContainer, ListContent, ListPageContainer } from '~/components/PageLayout';
import { Toolbar } from '~/components/toolbar';
import { useAppContext } from '~/contexts';
import { ChannelGrid } from './components';
import { LiveChannelsDocument } from './queries/list.generated';

export const LiveChannels = () => {
  const { t } = useTranslation();
  const { currentNetwork } = useAppContext();

  const { data, loading, error } = useQuery(LiveChannelsDocument, {
    variables: { networkId: currentNetwork.id },
  });

  const liveChannels = data?.network?.allChannels ?? [];

  if ((!loading && !data) || error) return <Navigate replace to="/not-found" />;

  return (
    <>
      <Helmet title={t('common.navigation.live_channels')} />
      <Toolbar titleIcon={<LiveTv />} titleText={t('common.navigation.live_channels')} />
      <ListPageContainer sx={{ overflow: 'auto' }}>
        <ListContainer sx={{ overflow: 'visible' }}>
          <ListContent sx={{ overflow: 'visible', pb: 2 }}>
            <ChannelGrid channels={liveChannels} loading={loading && !data} />
          </ListContent>
        </ListContainer>
      </ListPageContainer>
    </>
  );
};
